export enum FacilitySort {
  DISTANCE = 'distance',
  CREATED_AT = 'createdAt',
  MINIMUM_POINT = 'minimumPoint',
  REVIEW_COUNT = 'reviewCount',
  REVIEW_SCORE = 'reviewScore',
}

export enum FacilityOrder {
  ASC = 'asc',
  DESC = 'desc',
}
